module.exports = __webpack_public_path__ + "fonts/font.37679e1a.otf";